import { Button, Intent, Tooltip } from "@blueprintjs/core"
import { __ } from "src/libs/utilities"
import { HISTORY_TYPE, IHistoryStep, ILandingDelimiter, ILandingSection, SELECT_TYPE } from "src/modules/pe-landing-module/data/interfaces"
import { useLandingStore } from "src/modules/pe-landing-module/data/store"
import delimiterIcon from "../../../../assets/img/delimiter.svg"
import makeupIcon from "../../../../assets/img/makeup.svg"
import updateSection from "../utils/updateSection"

/* Protopia Ecosystem component */
export interface ITitleEditFormProps {
   section: ILandingSection
}
const DelimiterEditForm = (props: ITitleEditFormProps): JSX.Element => {
    const onEditTitle = () => {
        useLandingStore.setState({ 
            curEditModal: { 
                sectionId: props.section?.id, 
                currentEditType: SELECT_TYPE.DELIMITER,
            }            
        })
    } 
    const onMakeup = () => {
        useLandingStore.setState({ 
            isMakeupDrawerOpen: true,
            makeupType: SELECT_TYPE.DELIMITER
        })
    }
    const onDelete = () => { 
        const newVal: ILandingSection = {
            ...props.section,
            delimiter: {} as ILandingDelimiter
        }
        const step: IHistoryStep = {
            data: newVal,
            prevData: props.section,
            type: HISTORY_TYPE.SECTION,
            title: "Delete section delimiter"
        }
        updateSection(newVal, step)
    }
    return <div className='landing-data-edit-form-cont edit-full'>
        <div className="landing-data-content-container  text-light small">
            <Tooltip
                intent={Intent.PRIMARY}
                position="top-left"
                content={__("Edit delimiter")}
            >
                <Button 
                    intent={Intent.NONE}  
                    className={`p-1`} 
                    onClick={ onEditTitle }
                > 
                    <img
                        src={ delimiterIcon }
                        height={ 12 }
                        className="svg-force-contrast landing-icon my-2"
                        style={{
                            height: 12,
                            opacity: 1,
                        }}
                        alt=""
                    /> 
                </Button> 
            </Tooltip>  
            <Tooltip
                intent={Intent.PRIMARY}
                position="top-left"
                content={__("Makeup")}
            >
                <Button  
                    className={` p-1`}
                    intent={Intent.WARNING}
                    onClick={ onMakeup }
                > 
                    <img
                        src={ makeupIcon }
                        height={ 12 }
                        className="svg-force-contrast landing-icon my-2"
                        style={{
                            height: 12,
                            opacity: 1,
                        }}
                        alt=""
                    />
                </Button> 
            </Tooltip> 
            <Tooltip
                intent={Intent.PRIMARY}
                position="top-left"
                content={__("Delete")}
            >
                <Button icon="trash" className="p-2 ml-1 " intent={Intent.DANGER} onClick={onDelete}  /> 
            
            </Tooltip>
        </div>
    </div>
}
export default DelimiterEditForm